var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"context-menu-container"},[_c('li',{on:{"click":_vm.onCloseRightClick}},[_vm._v("\n\t\t关闭右侧\n\t")]),_vm._v(" "),_c('li',{on:{"click":_vm.onCloseOtherClick}},[_vm._v("\n\t\t关闭其他\n\t")]),_vm._v(" "),_c('li',{on:{"click":_vm.onCloseAllClick}},[_vm._v("\n\t\t关闭全部\n\t")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c8241b5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/components/TagsView/ContextMenu.vue
// module id = null
// module chunks = 